import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import {TranslateService} from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';
import { GalleryService } from '../rest/api/gallery.service';
import { MemberService } from '../rest/api/member.service';

@Component({
  selector: 'app-scenes',
  templateUrl: './scenes.component.html',
  styleUrls: ['./scenes.component.scss']
})
export class ScenesComponent implements OnInit {
  searchForm: FormGroup;

  accessToken: any;

  spaceCategoryData: any;
  categoryId = '';
  langShortCode: any;
  languageData: any;
  galleryList: any;
  lang: any;
  totalCount: number;
  itemsPerPage = 9;
  currentPage = 1;
  pageLoader = true;

  isSubmitted = false;

  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    private authService: AuthService,
    public galleryService: GalleryService,
    public translateService: TranslateService,
    public memberService: MemberService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
    this.searchFormInit();
  }

  searchFormInit() {
    this.searchForm = this.fb.group({
      categoryId: [''],
      keywords: ['']
    });
  }

  submit(value) {
    if (this.isSubmitted) {
      return;
    }
    this.isSubmitted = true;
    const categoryId = value.categoryId ? value.categoryId : '';
    const keywords = value.keywords ? value.keywords : '';
    this.pageLoader = true;
    this.currentPage = 1;
    this.getAllGalleryList(this.currentPage, this.itemsPerPage, categoryId, keywords);
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getSpaceCategory();
    this.getAllGalleryList(this.currentPage, this.itemsPerPage, '', '');
    this.languageData = this.route.snapshot.data.language;
  }

  getAllGalleryList(page, limit, categoryId, keywords) {
    const thisobject = this;
    this.galleryService.getGalleryList({
      page: page,
      paginate: limit,
      category: categoryId || undefined,
      keywords: keywords || undefined,
      lang: this.lang
    }).subscribe((response: any) => {
      thisobject.pageLoader = false;
      this.galleryList = response && response.data ? response.data : [];
      // this.galleryList = _.orderBy(this.galleryList, ['published_date'], ['desc']);
      this.totalCount = response && response.meta && response.meta.pagination && response.meta.pagination.total ? response.meta.pagination.total : 0;
      this.isSubmitted = false;
    }, err => {
      thisobject.pageLoader = false;
      this.isSubmitted = false;
      this.galleryList = [];
    });
  }

  getSpaceCategory() {
    if (this.langShortCode) {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken,
        lang: this.langShortCode
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    } else {
      this.memberService.getSpaceCategory({
        Authorization: this.accessToken
      }).subscribe((response: any) => {
        this.spaceCategoryData = response && response.data ? response.data : [];
      }, err => {
        this.spaceCategoryData = [];
      });
    }
  }

  pageChanged(event) {
    const categoryId = this.searchForm && this.searchForm.value && this.searchForm.value.categoryId ? this.searchForm.value.categoryId : '';
    const keywords = this.searchForm && this.searchForm.value && this.searchForm.value.keywords ? this.searchForm.value.keywords : '';
    this.pageLoader = true;
    this.currentPage = event;
    this.getAllGalleryList(event, this.itemsPerPage, categoryId, keywords);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

}
